enum TRANSACTION_STATUS {
  PENDING = 0,
  COMPLETED = 1,
  FAILED = 2,
}

export default TRANSACTION_STATUS;
